import React from 'react';

import { useAppSelector } from 'state/hooks';
import { selectUser } from 'state/userSlice';
import { selectCurrentProjectInfo, selectWorkflow } from 'state/workflowSlice';

import { WorkflowType } from 'appConstants';
import { WorkflowDetour } from 'features/workflow_detour/WorkflowDetour';
import { useBlockGlobalUndoOutsideInputs } from 'features/workflow_detour/hooks/useBlockGlobalUndoOutsideInputs';
import { WorkflowSpeed } from 'features/workflow_nrt/WorkflowSpeed';
import { WorkflowOriginDestination } from 'features/workflow_origindestination/WorkflowOriginDestination';
import { WorkflowPlanning } from 'features/workflow_planning/WorkflowPlanning';
import { WorkflowRouteMonitoring } from 'features/workflow_routemonitoring/WorkflowRouteMonitoring';
import { WorkflowTimeline } from 'features/workflow_timeline/WorkflowTimeline';
import { WorkflowTravelTime } from 'features/workflow_traveltime/WorkflowTravelTime';

import { useAppDispatchUserStatus } from '../../app/AppDispatcher';
import {
  NoDataLoadedWarning,
  useHasNoRelevantData,
} from '../workflow_common/NoDataLoadedWarning';
import { WorkflowQueuing } from '../workflow_queuing/WorkflowQueuing';

import styles from './Workspace.module.css';

export function NoProjectsPage() {
  return (
    <div className={styles.noprojects}>
      <p>You do not currently have access to any projects on this product</p>
      <p>Please contact support@streetlightdata.com</p>
    </div>
  );
}

export function Workspace() {
  const workflow = useAppSelector(selectWorkflow);
  const userProject = useAppSelector(selectCurrentProjectInfo);
  const user = useAppSelector(selectUser);
  useAppDispatchUserStatus();
  useBlockGlobalUndoOutsideInputs();
  const hasNoRelevantData = useHasNoRelevantData();
  // console.log(`Login userStatus: ${userStatus}`);
  if (!userProject) {
    if (user && user.projects.length < 1) {
      return <NoProjectsPage />;
    } else {
      return null;
    }
  }
  if (hasNoRelevantData) {
    return <NoDataLoadedWarning />;
  }

  /* eslint-disable */
  switch (workflow) {
    case WorkflowType.Plan:
      return <WorkflowPlanning />;
    case WorkflowType.TravelTime:
      return <WorkflowTravelTime />;
    case WorkflowType.Speed:
      return <WorkflowSpeed />;
    case WorkflowType.Timeline:
      return <WorkflowTimeline />;
    case WorkflowType.Queuing:
      return <WorkflowQueuing />;
    case WorkflowType.Detouring:
      return <WorkflowDetour />;
    case WorkflowType.RouteMonitoring:
      return <WorkflowRouteMonitoring />;
    case WorkflowType.OriginDestination:
      return <WorkflowOriginDestination />;
    default:
      return null;
  }
  /* eslint-enable */
}
